import { render, staticRenderFns } from "./TemplateUpdate.vue?vue&type=template&id=cd682c54&lang=pug"
import script from "./TemplateUpdate.vue?vue&type=script&lang=js"
export * from "./TemplateUpdate.vue?vue&type=script&lang=js"
import style0 from "./TemplateUpdate.vue?vue&type=style&index=0&id=cd682c54&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports